import {
  DashboardWidgetUnion,
  getDashboardWidgetPosition,
} from '@akin-home/dashboards';
import styled from 'styled-components/native';
import FullScreenLoader from '../../components/FullScreenLoader';
import { useStateStore } from '../../stores/useStateStore';
import { DashboardTileContent } from '../DashboardTileContent/DashboardTileContent';
import { DashboardScreenViewProps } from './types';

export const LandscapeDashboardScreenView = (
  props: DashboardScreenViewProps
) => {
  const { dashboard } = props;

  const { width, orientation, cell_layout } = useStateStore(
    (state) => state.dashboard_layout
  );

  if (dashboard && width) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {dashboard.layout?.map((tile) => (
          <Tile
            key={`${dashboard?.id}${tile.id}`}
            widget={tile}
            orientation={orientation}
            cell_dimensions={cell_layout}
          />
        ))}
      </>
    );
  } else {
    return <FullScreenLoader />;
  }
};

interface TileProps {
  widget: DashboardWidgetUnion;
  orientation: 'portrait' | 'landscape';
  cell_dimensions: { height: number; width: number };
}

const Tile = ({ widget, orientation, cell_dimensions }: TileProps) => {
  const style = getDashboardWidgetPosition(
    widget,
    orientation,
    cell_dimensions
  );

  return (
    <TileContainer style={style}>
      <DashboardTileContent
        widget={widget}
        height={style.height}
        width={style.width}
      />
    </TileContainer>
  );
};

const TileContainer = styled.View`
  position: absolute;
  padding: 8px;
`;
